import { AxiosError } from "axios";
import * as R from "../../../requests/x2y/requestCreators";
import { FlowioThunkCreator } from "../../types";
import * as AC from "../actionCreators";
import * as S from "../selectors";
import { X2yController } from "../types";

type MakeThunkCreatorParams = {
  controller: X2yController;
};

// Thunk creator types
type ThunkCreatorParams = { xIds: number[] };

export type BulkFetchThunkCreator = FlowioThunkCreator<ThunkCreatorParams>;
export type MakeBulkFetchThunkCreator = (
  p: MakeThunkCreatorParams
) => BulkFetchThunkCreator;

// ==== FACTORY ====
const createBulkFetchThunk: MakeBulkFetchThunkCreator = ({ controller }) => {
  const getNonFetchingIdSubset = S.createGetNonFetchingIdSubset(controller);
  const request = R[controller].getBulk;

  return ({ xIds }) =>
    (dispatch, getState) =>
      Promise.resolve().then(async () => {
        // Trimni idčka, pro který už fetchuješ a fetchni jenom pro zbytek
        const idsToFetch = getNonFetchingIdSubset(getState(), xIds);
        if (idsToFetch.length === 0) return;

        const reqPayload = { controller, xIds: idsToFetch };
        dispatch(AC.bulkGetX2yRequest(reqPayload));

        try {
          const response = await request(xIds);
          const recPayload = {
            controller,
            xIds: idsToFetch,
            x2ys: response.data,
          };
          dispatch(AC.bulkGetX2yReceive(recPayload));
        } catch (error) {
          const errPayload = {
            controller,
            xIds: idsToFetch,
            error: (error as AxiosError).response || error,
          };
          dispatch(AC.bulkGetX2yError(errPayload));
        }
      });
};

export default createBulkFetchThunk;
